import { useEffect } from "react";

type DisableBackgroundScrollingOptions = {
    targetId?: string;
    opacity?: string;
    className?: string;
};

export const useDisableBackgroundScrolling = (
    isOpen: boolean,
    className: string = "",
    options?: DisableBackgroundScrollingOptions,
) => {
    const {
        targetId = "main-content",
        opacity = "0.3",
    } = options || {};

    useEffect(() => {
        const mainContent = document.getElementById(targetId);

        if (!mainContent) return;

        const blockedKeys = [
            "ArrowUp",
            "ArrowDown",
            "PageUp",
            "PageDown",
            "Home",
            "End",
            " ",
        ];

        const preventScroll = (
            e: KeyboardEvent | WheelEvent | TouchEvent
        ) => {
            if (e instanceof KeyboardEvent) {
                if (blockedKeys.includes(e.key)) {
                    e.preventDefault();
                }
            } else {
                e.preventDefault();
            }
        };

        const cleanup = () => {
            window.removeEventListener("keydown", preventScroll);
            window.removeEventListener("wheel", preventScroll);
            window.removeEventListener("touchmove", preventScroll);

            mainContent.classList.remove("pointer-events-none");
            mainContent.style.opacity = "";
            mainContent.style.backdropFilter = "";
        };

        if (isOpen && className !== "hidden") {
            window.addEventListener("keydown", preventScroll, {
                passive: false,
            });

            window.addEventListener("wheel", preventScroll, {
                passive: false,
            });

            window.addEventListener("touchmove", preventScroll, {
                passive: false,
            });

            mainContent.classList.add("pointer-events-none");
            mainContent.style.opacity = opacity;
        } else {
            cleanup();
        }

        return cleanup;
    }, [isOpen, className, targetId, opacity]);
};